import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ApplicationPackage} from 'src/app/enums/application-package.enum';
import {Service} from 'src/app/enums/service.enum';
import {CustomHttpUrlEncodingCodec} from 'src/app/main/encoder';
import {PageOfValidationEventActivityLog} from 'src/app/model/cms-vod-core/validation-event-models/validation-event-activity-log.model';
import {VodQueryParams} from 'src/app/model/vod-query-params.model';
import {environment} from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class ValidationEventActivityLogService {

  constructor(private http: HttpClient) { }

  readonly validationEventLogApi = environment.endPoint + ApplicationPackage.CMS_VOD + Service.VALIDATION_EVENT_ACTIVITY_LOGS;

  getValidationEventActivityLogs(queryParam?: VodQueryParams): Observable<PageOfValidationEventActivityLog> {
    let queryParams: HttpParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    queryParam.page = queryParam.page - 1;

    if (queryParam.page >= 0) {
      queryParams = queryParams.set('page', <any>queryParam.page);
    }
    if (queryParam.itemCount) {
      queryParams = queryParams.set('itemCount', <any>queryParam.itemCount);
    }
    if (queryParam.name) {
      queryParams = queryParams.set('name', <any>queryParam.name);
    }
    if (queryParam.actionTimeStart) {
      queryParams = queryParams.set('actionTimeStart', <any>queryParam.actionTimeStart);
    }
    if (queryParam.actionTimeEnd) {
      queryParams = queryParams.set('actionTimeEnd', <any>queryParam.actionTimeEnd);
    }
    if (queryParam.vodType) {
      queryParams = queryParams.set('vodType', <any>queryParam.vodType);
    }
    if (queryParam.action) {
      queryParams = queryParams.set('action', <any>queryParam.action);
    }
    if (queryParam.userId) {
      queryParams = queryParams.set('userId', <any>queryParam.userId);
    }
    if (queryParam.userName) {
      queryParams = queryParams.set('userName', <any>queryParam.userName);
    }
    if (queryParam.issueTypeId) {
      queryParams = queryParams.set('issueTypeId', <any>queryParam.issueTypeId);
    }
    if (queryParam.validationChangeType) {
      queryParams = queryParams.set('changeType', <any>queryParam.validationChangeType);
    }
    if (queryParam.sortParam) {
      queryParams = queryParams.set('sortParam', <any>queryParam.sortParam);
    }

    return this.http.get<PageOfValidationEventActivityLog>(this.validationEventLogApi, {params: queryParams});
  }

  generateValidationEventActivityLogsReport(queryParam?: VodQueryParams): Observable<any> {
    let queryParams: HttpParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    if (queryParam.name) {
      queryParams = queryParams.set('name', <any>queryParam.name);
    }
    if (queryParam.actionTimeStart) {
      queryParams = queryParams.set('actionTimeStart', <any>queryParam.actionTimeStart);
    }
    if (queryParam.actionTimeEnd) {
      queryParams = queryParams.set('actionTimeEnd', <any>queryParam.actionTimeEnd);
    }
    if (queryParam.vodType) {
      queryParams = queryParams.set('vodType', <any>queryParam.vodType);
    }
    if (queryParam.action) {
      queryParams = queryParams.set('action', <any>queryParam.action);
    }
    if (queryParam.userId) {
      queryParams = queryParams.set('userId', <any>queryParam.userId);
    }
    if (queryParam.userName) {
      queryParams = queryParams.set('userName', <any>queryParam.userName);
    }
    if (queryParam.issueTypeId) {
      queryParams = queryParams.set('issueTypeId', <any>queryParam.issueTypeId);
    }
    if (queryParam.validationChangeType) {
      queryParams = queryParams.set('changeType', <any>queryParam.validationChangeType);
    }
    if (queryParam.sortParam) {
      queryParams = queryParams.set('sortParam', <any>queryParam.sortParam);
    }

    return this.http.get<any>(this.validationEventLogApi + '/report', {params: queryParams, responseType: 'text' as 'json'});
  }
}
